
export const theme_ns: ThemeNS = 'citycon2023';
